export default __webpack_public_path__ + "static/media/LAS0720.34I-37960_-22230_0.27f6e5bb.jpg";